import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

const RayaField = React.forwardRef((props, ref) => {
    const { t } = useTranslation();

    return (
        <TextField
            {...props}
            required={false}
            label={props.optional ? `${props.label}${t('optionalField')}` : props.label}
            color="field"
            className={clsx('raya-field', props.className)}
            inputRef={ref}  // Forward the ref to the actual TextField
        />
    );
});

export default RayaField;
